import { selfAxios } from "../../../../../axios/selfAxios.js";
async function postBatchQueryActivityTypeByCondition(params) {
  const res = await selfAxios.post(`/designapi/design/retailOrder/batchQueryActivityTypeByCondition`, params);
  return res.data;
}
export { postBatchQueryActivityTypeByCondition };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designapi/design/retailOrder/batchQueryActivityTypeByCondition/post.js